export enum EPlatformWhatsAppConversationStatus {
  Open = 0,
  HumanHandoff = 1,
  Paused = 2,
  Closed = 3,
  Blocked = 4,
}
